/* eslint-disable no-case-declarations */
import axios from 'axios';
import { takeLatest, call, put } from 'redux-saga/effects';
import { createCheckoutRequest } from '../../../../common/apiRequest';
import {
  addOrderIDAttributeToCart,
  goToCartPermalink,
} from '../../../../common/cart';

import {
  goToCheckout,
  goToDiscountedCheckout,
} from '../../../../common/navigation';
import { getShop } from '../../../../common/pageData';
import { getOrderID, setMrDiscountCode } from '../../../../common/settings';
import { ADD_TO_CART_SUCCESS } from '../../Init/constants';
import {
  CHECKOUT,
  CHECKOUT_SUCCESS,
  CHECKOUT_ERROR,
  CHECKOUT_API,
  DISCOUNT_CODE_APPLY_SUCCESS,
} from '../constants';
import { logger } from '../../../../common/logger';

function* checkoutWorker(action) {
  try {
    // checout to be done in case of add to cart success
    if (action.type === ADD_TO_CART_SUCCESS) {
      const {
        datapack: {
          theme: { isProductButtonActionCheckout },
          isEmbedded,
          discountCode,
        },
      } = action;

      // don't do anything if product button action is not checkout or embedded display
      if (!isProductButtonActionCheckout || isEmbedded) {
        return;
      }
      // don't display discount code popup
      discountCode.action = 'checkout';
      action.discountCode = discountCode;
    }

    const {
      isStorefrontCart,
      orderRequest,
      appliedShopifyFunctionCodes,
    } = yield createCheckoutRequest(
      'offer',
      action.variants,
      false,
      action.discountCode,
    );

    // let formData = { quantity: 1, id: action.variant.id };

    const httpArgs = [CHECKOUT_API, orderRequest];
    const { data, status } = yield call(axios.post, ...httpArgs);
    if (status === 200) {
      const { discount_applicable, discountCode, isZeroDiscount } = data;

      if (discount_applicable) {
        // for zero discount add an attribute to cart so that
        // it can be detected in webhook to backend.
        // continue as normal checkout so that discount code can be applied
        if (isZeroDiscount) {
          const mrOrderID = getOrderID();
          yield call(addOrderIDAttributeToCart, mrOrderID);
          if (getShop() === 'artadamell-deutschland.myshopify.com') {
            goToCartPermalink({
              cart: orderRequest['cart'],
              orderid: mrOrderID,
            });
          } else {
            goToCheckout({
              discountCodes: appliedShopifyFunctionCodes,
              isStorefrontCart,
            });
          }

          return;
        }

        if (action.discountCode.action === 'apply') {
          if (discountCode.code && discountCode.code !== '') {
            setMrDiscountCode(discountCode.code);
          }
          yield put({ type: DISCOUNT_CODE_APPLY_SUCCESS, discountCode });
          return;
        }
        goToDiscountedCheckout(data);
      } else {
        //remove the monk identifier if no offers are applicable
        //and the monk identifier is set in cart
        if (
          orderRequest.properties &&
          orderRequest.properties.mrOrderID &&
          orderRequest.properties.mrOrderID !== ''
        ) {
          yield call(addOrderIDAttributeToCart, '');
        }
        goToCheckout({ discountCodes: appliedShopifyFunctionCodes });
      }
    } else {
      yield put({ type: CHECKOUT_ERROR });
    }
  } catch (e) {
    logger.log(e);
    //     yield put({ type: CHECKOUT_ERROR, variantid: action.variant.id });
  }
}

export default function* checkoutWatcher() {
  yield takeLatest([CHECKOUT, ADD_TO_CART_SUCCESS], checkoutWorker);
}
